import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { KitService } from "src/shared/kit.service";
import { map } from 'rxjs/operators';

@Component({
  selector: "app-choose-clothes",
  templateUrl: "./choose-clothes.component.html",
  styleUrls: ["./choose-clothes.component.scss"],
})
export class ChooseClothesComponent implements OnInit {
  public maillotsColRond: Array<any>;
  public maillotsColV: Array<any>;
  public shortModeles = [];

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private kitService: KitService
  ) {}

  ngOnInit(): void {
    this.http
      .get<any>("https://strapi.alkesoccer.com/maillot-modeles?Col_type=Rond")
      .pipe(
        map((data) => data.sort((a, b) => a.index - b.index))
      )
      .subscribe((data) => {
        this.maillotsColRond = data;
      });
    this.http
      .get<any>("https://strapi.alkesoccer.com/maillot-modeles?Col_type=V")
      .pipe(
        map((data) => data.sort((a, b) => a.index - b.index))
      )
      .subscribe((data) => {
        this.maillotsColV = data;
      });

    this.http
      .get<any>("https://strapi.alkesoccer.com/short-modeles")
      .subscribe((data) => {
        this.shortModeles = data;
      });
  }

  goNextStep(maillot) {
    if (this.kitService.getJersey()?.maillot_modele.id != maillot.id) {
      this.kitService.resetJersey();
    }
    if(this.kitService.getStep() == KitService.STEPS.CHOOSE_CLOTHES){
      this.kitService.setStep(KitService.STEPS.JERSEY);
    }
    this.router.navigate(["jersey/step1", maillot.id]);
  }

  goNextStepShort(short) {
    if (this.kitService.getShort()?.short_modele.id != short.id) {
      this.kitService.resetShort();
    }
    if(this.kitService.getStep() == KitService.STEPS.CHOOSE_CLOTHES){
      this.kitService.setStep(KitService.STEPS.SHORT);
    }
    this.router.navigate(["shorts-socks/step2", short.id]);
  }

}
